import { render, staticRenderFns } from "./ListErroIntegracaoView.vue?vue&type=template&id=9884e034&"
import script from "./ListErroIntegracaoView.vue?vue&type=script&lang=ts&"
export * from "./ListErroIntegracaoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports